module.exports = __webpack_public_path__ + "img/back.d7e277a0.svg";